import comp from "./PlannerElementDataSet";
export default comp;
